import type { MouseEvent } from 'react'

interface Props {
  on: boolean
  disabled?: boolean
  /** When true, render the disabled style as "locked / not authorized" rather than "device offline". */
  locked?: boolean
  size?: number
  onClick: () => void
}

export function PowerButton({ on, disabled, locked, size = 44, onClick }: Props) {
  const handle = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    if (!disabled) onClick()
  }
  const label = locked ? 'Riservato amministratori' : on ? 'Spegni' : 'Accendi'
  return (
    <button
      className="pwr-btn"
      data-on={on}
      data-disabled={disabled}
      data-locked={locked}
      disabled={disabled}
      aria-pressed={on}
      aria-label={label}
      title={label}
      style={{ width: `${size}px`, height: `${size}px` }}
      onClick={handle}
    >
      <svg
        width={Math.round(size * 0.5)} height={Math.round(size * 0.5)} viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
      >
        <path d="M18.36 6.64a9 9 0 1 1-12.73 0" />
        <line x1="12" y1="2" x2="12" y2="12" />
      </svg>
    </button>
  )
}
